/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:22
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      var weeklystats_id = this.data.get("id");
      // console.log("-=> weeklystats_controller connected (" + weeklystats_id + ")");
    }


    initialize() {
      $('select.dropdown')
        .dropdown()
      ;
    }

  
// onchange="javascript:selector_to_url('resume', $(this).val());"

  selector_to_url() {
    var suffix = event.currentTarget.dataset['weeklystatsSuffix'];
    var selected_id = event.currentTarget.value;

    if (selected_id == 0)  {
      window.location='/weekly_stats/';
    } else {
      window.location='/weekly_stats/' + suffix + '/' + selected_id;
    }
  }

  reload_with_span() {
    // Leave this as reference in case I start adding multiple options
    // http://stackoverflow.com/questions/4651990/remove-url-parameters-with-javascript-or-jquery
    // http://stackoverflow.com/questions/5997450/append-to-url-and-refresh-page
    //
    //var url = window.location.href;
    //if (url.indexOf('?') > -1){
    //   url += '&span=' + s
    //}else{
    //   url += '?span=' + s
    //}
    //window.location.href = url;
    var span = event.currentTarget.value;
    window.location.href = window.location.href.split( '?' )[0] + "?span=" + span;
  }


  };

// console.log("-=> weeklystats_controller loaded");
